"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetSalesmanDetails = void 0;
const Base_1 = require("./Base");
exports.GetSalesmanDetails = {
    url: Base_1.URL_BASE + "/GetSalesmanDetails",
    method: "GET",
    secure: true
};
//# sourceMappingURL=GetSalesmanDetails.js.map